/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AffiliatedGroupDetail } from '../../models/affiliated-group-detail';

export interface GetAffiliatedGroup$Params {
  id: number;
}

export function getAffiliatedGroup(http: HttpClient, rootUrl: string, params: GetAffiliatedGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<AffiliatedGroupDetail>> {
  const rb = new RequestBuilder(rootUrl, getAffiliatedGroup.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AffiliatedGroupDetail>;
    })
  );
}

getAffiliatedGroup.PATH = '/rest/admin/affiliated-group/{id}';
